import styled from 'styled-components';

export const InfoList = styled.div<{ $show?: boolean }>(
  ({ $show }) => `
  display: ${$show ? 'flex' : 'none'};
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;

  list-style-type: none;
`,
);

export const InfoListItem = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  color: #c4c4c4;

  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: 'Akkurat LL';
  font-size: ${theme.fontSizes.small};
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.56px;
`,
);
